import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const brandsApi = createApi({
  reducerPath: "brandsApi",
  baseQuery: fetchBaseQuery({ 
    baseUrl: import.meta.env.VITE_API + "brand",
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) =>({
    getBrands: builder.query({
        query: (query) => ({
        url: query ? query : "",
        method: "GET",
        }),
        transformResponse: (response, meta, arg) => response.data,
        
    })
  })
});

export const { useGetBrandsQuery  } = brandsApi;